import moment from "moment";
class conceptToConceptSalary {
  constructor(name, dateStart, dateEnd, conceptoId) {
    this.name = name;
    this.fecDesde = dateStart
      ? moment.utc(dateStart).format("DD-MM-YYYY")
      : null;
    this.fecHasta = dateEnd ? moment.utc(dateEnd).format("DD-MM-YYYY") : null;
    this.dateStartInput = dateStart;
    this.dateEndInput = dateEnd;
    this.conceptoId = conceptoId;
  }
  static fromJson({ nombre, fecDesde, fecHasta, conceptoId }) {
    return new conceptToConceptSalary(nombre, fecDesde, fecHasta, conceptoId);
  }
}
export default conceptToConceptSalary;
